import { createYotpoClient } from "./createYotpoClient"

export const yotpoClient = createYotpoClient({
  apiKey: process.env.GATSBY_YOTPO_API_KEY ?? "",
})

export const useReviewClient = () => {
  return {
    client: yotpoClient,
  }
}
